export default __webpack_public_path__ + "static/media/2.332f7031.png";